export const ID_ESTADO_PENDIENTE = 0
export const ID_ESTADO_EN_PREPARACION = 0
export const ID_ESTADO_ENVIADO = 1
export const ID_ESTADO_ENTREGADO = 2
export const ID_ESTADO_ENTREGA_OBSERVADA = 3
export const ID_ESTADO_MONTOS_OK = 4
export const ID_ESTADO_MONTOS_NO_OK = 5
export const ID_ESTADO_EN_ESPERA = 6
export const ID_ESTADO_PENDIENTE_PAGO = 7
export const ID_ESTADO_CONFIRMADO = 8
export const ID_ESTADO_CANCELADO = 9
export const ID_ESTADO_DEVUELTO = 10
export const ID_ESTADO_NO_CONFIRMADO = 11
export const ID_INICIO_DE_CANCELACION = 13
export const ID_INICIO_DE_DEVOLUCION = 14

export const TIPO_COMISION_POR_PUBLICAR = 'Comisión por Publicar'

export const estadoPendientePercepciones = [ID_ESTADO_MONTOS_OK, ID_ESTADO_MONTOS_NO_OK]
export const estadoNoPermiteComprar = [...estadoPendientePercepciones, ID_ESTADO_NO_CONFIRMADO]

export const ESTADO_REVISION = {
  variante: 'pendiente',
  icono: 'fa-search',
  titulo: 'Tu pedido está en revisión por el vendedor',
  subtitulo: null,
  badge: { texto: 'En revisión', clase: 'statusPendiente', icono: 'fa-clock-o' }
}

export const ESTADOS_COMPROBANTE = {
  [ID_ESTADO_CONFIRMADO]: {
    variante: 'exito',
    icono: 'fa-check',
    titulo: 'Tu pedido fue confirmado',
    subtitulo: 'La operación finalizó correctamente. El vendedor ya puede prepararlo.',
    badge: { texto: 'Confirmado', clase: 'statusConfirmado', icono: 'fa-check' }
  },
  [ID_ESTADO_PENDIENTE_PAGO]: {
    variante: 'exito',
    icono: 'fa-check',
    titulo: 'Tu pedido fue confirmado',
    subtitulo: 'Solo falta completar el pago para que el vendedor pueda prepararlo.',
    badge: { texto: 'Pendiente de pago', clase: 'statusPendiente', icono: 'fa-credit-card' }
  },
  [ID_ESTADO_EN_ESPERA]: {
    variante: 'pendiente',
    icono: 'fa-exclamation',
    titulo: 'Tu pedido fue creado',
    subtitulo: 'Necesita tu reconfirmación para poder avanzar.',
    badge: {
      texto: 'Requiere reconfirmación',
      clase: 'statusPendiente',
      icono: 'fa-exclamation-circle'
    }
  },
  [ID_ESTADO_NO_CONFIRMADO]: {
    variante: 'pendiente',
    icono: 'fa-hourglass-half',
    titulo: 'Tu pedido está pendiente de aprobación',
    subtitulo: 'Cuando se libere recibirás una notificación.',
    badge: {
      texto: 'Pendiente de aprobación',
      clase: 'statusPendiente',
      icono: 'fa-hourglass-half'
    }
  }
}
